import { inject, Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { IHelpExtensionHandler, WeatherService, WeatherConfig, WdWeatherConfigModalComponent } from '@luzula/luzula-lib';
import { FbfPickerModalComponent } from './fbf-picker-modal.component';
import { MoorsubstratInfoModalComponent } from './moorsubstrat-info-modal.component';
import { TorfMuddeArtenInfoModalComponent } from './torf-muddearten-info-modal.component';
import { ZersetzungsgradInfoModalComponent } from './zersetzungsgrad-info-modal.component';
import { WasserformInfoModalComponent } from './wasserform-info-modal.component';
import { AuthService } from 'src/app/auth.service';
import { AufnahmePunktDocument } from 'src/app/data-model';

@Injectable()
export class BohrpunktHelpExtensionHandler implements IHelpExtensionHandler {
	private authService = inject(AuthService);
	private weatherService = inject(WeatherService);

	canHandle(name: string): boolean {
		return name === 'Witterung' || name === 'Feinbodenform' || name.startsWith('Feinbodenform[') || name === 'Moorsubstrat' || name === 'TorfMuddeArten' || name === 'Zersetzungsgrad' || name === 'Wasserform' || name === 'Wasserform2';
	}

	openHelp(name: string, context: Record<string, any>, modalService: NgbModal): Promise<any> | void {
		if (name === 'Witterung') {
			const bohrpunkt = context['bohrpunkt'] as AufnahmePunktDocument | undefined;
			const modalRef = modalService.open(WdWeatherConfigModalComponent, { centered: true, size: 'lg' });
			modalRef.componentInstance.canEdit = this.authService.canIbe('manager') || this.authService.canIbe('entwickler');
			modalRef.componentInstance.hasRawData = !!bohrpunkt?.extendedHeader?.witterungRohdaten;
			modalRef.componentInstance.rawData = bohrpunkt?.extendedHeader?.witterungRohdaten;
			modalRef.componentInstance.reinterpretFn = (rohdaten: any, _config: WeatherConfig) => {
				return this.weatherService.reinterpretRohdaten(rohdaten).full;
			};
			modalRef.componentInstance.reinterpreted.subscribe((result: string) => {
				if (bohrpunkt?.extendedHeader) {
					bohrpunkt.extendedHeader.witterung = result;
				}
			});
			return;
		}

		if (name === 'Moorsubstrat') {
			modalService.open(MoorsubstratInfoModalComponent, { centered: true, size: 'lg', scrollable: true });
			return;
		}

		if (name === 'TorfMuddeArten') {
			modalService.open(TorfMuddeArtenInfoModalComponent, { centered: true, size: 'xl', scrollable: true });
			return;
		}

		if (name === 'Zersetzungsgrad') {
			modalService.open(ZersetzungsgradInfoModalComponent, { centered: true, size: 'xl', scrollable: true });
			return;
		}

		if (name === 'Wasserform' || name === 'Wasserform2') {
			const modalRef = modalService.open(WasserformInfoModalComponent, { centered: true, size: 'xl', scrollable: true });
			modalRef.componentInstance.activeTab = name === 'Wasserform2' ? 'stau' : 'grund';
			return;
		}

		if (name === 'Feinbodenform' || name.startsWith('Feinbodenform[')) {
			const modalRef = modalService.open(FbfPickerModalComponent, {
				centered: true,
				scrollable: true,
				size: 'lg'
			});
			modalRef.componentInstance.currentValue = context['currentValue'];
			modalRef.componentInstance.hbfFilter = context['hbfFilter'];
			return modalRef.result;
		}
	}
}
